module.exports = __webpack_public_path__ + "img/LogoMDG.98f28bc0.png";